var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "whatsappcontactlist" } },
    [
      _c(
        "div",
        { staticClass: "my-1 wp-list-searching-input" },
        [
          _c("b-button", { staticClass: "m-2", on: { click: _vm.refresh } }, [
            _vm._v(_vm._s(_vm.$t("message.refresh"))),
          ]),
          _vm._v(" "),
          _c("a-input-search", {
            staticClass: "search-input",
            attrs: { placeholder: _vm.$t("message.search") },
            on: {
              input: function ($event) {
                return _vm.onSearch($event.target.value)
              },
            },
            model: {
              value: _vm.searchText,
              callback: function ($$v) {
                _vm.searchText = $$v
              },
              expression: "searchText",
            },
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "mr-5" },
            [
              _c("a-button", { on: { click: _vm.showModal } }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("wp.startChatWithAnyNo")) +
                    "\n            "
                ),
              ]),
              _vm._v(" "),
              _c(
                "a-modal",
                {
                  staticClass: "row d-flex flex-row",
                  attrs: {
                    title: _vm.$t("wp.typeInANumberDesc"),
                    visible: _vm.visible,
                    "confirm-loading": _vm.confirmLoading,
                  },
                  on: {
                    ok: function ($event) {
                      return _vm.handleOk(_vm.wpContactNumber)
                    },
                    cancel: _vm.handleCancel,
                  },
                },
                [
                  _vm.showAlertMessage
                    ? _c(
                        "div",
                        { staticClass: "pb-3" },
                        [
                          _c("a-alert", {
                            attrs: {
                              message: _vm.$t("wp.toLittleChar"),
                              type: "error",
                              banner: "",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex flex-row align-items-center justify-content-center",
                    },
                    [
                      _c("vue-country-code", {
                        staticClass: "col-3 country-code",
                        attrs: {
                          enabledCountryCode: true,
                          defaultCountry: _vm.userLastCountry,
                        },
                        on: {
                          onSelect: function ($event) {
                            return _vm.onSelect($event)
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-8" },
                        [
                          _c("a-input", {
                            directives: [
                              {
                                name: "mask",
                                rawName: "v-mask",
                                value: "##########",
                                expression: "'##########'",
                              },
                            ],
                            attrs: {
                              placeholder: _vm.$t("message.phone"),
                              autocomplete: "off",
                              trim: "",
                              type: "text",
                            },
                            model: {
                              value: _vm.wpContactNumber,
                              callback: function ($$v) {
                                _vm.wpContactNumber = $$v
                              },
                              expression: "wpContactNumber",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("a-table", {
        key: "vtable-" + _vm.renderCount,
        staticClass: "custom-table",
        attrs: {
          columns: _vm.cols,
          dataSource: _vm.getOnlyPersonelContacts,
          pagination: _vm.pagination,
          loading: _vm.loading,
          locale: {
            emptyText: _vm.$t("message.noContactFound"),
          },
          rowKey: "id",
          size: "small",
        },
        on: { change: _vm.handleTableChange },
        scopedSlots: _vm._u([
          {
            key: "avatarSlot",
            fn: function (data, item) {
              return _c(
                "div",
                { staticClass: "p-1" },
                [
                  _c(
                    "a-avatar",
                    {
                      staticStyle: {
                        "background-color": "#3899ff",
                        "border-radius": "7px !important",
                      },
                      attrs: {
                        size: 30,
                        shape: "square",
                        username: item.name,
                        src: _vm.$_.get(item, "profilePicThumbObj.eurl"),
                      },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(item.name.substr(0, 1).toLocaleUpperCase()) +
                          "\n            "
                      ),
                    ]
                  ),
                ],
                1
              )
            },
          },
          {
            key: "action",
            fn: function (data, item) {
              return _c("div", {}, [
                _c(
                  "div",
                  {
                    staticClass: "d-flex justify-content-end",
                    staticStyle: { "margin-right": "-10px !important" },
                  },
                  [
                    _c(
                      "md-button",
                      {
                        directives: [
                          {
                            name: "tippy",
                            rawName: "v-tippy",
                            value: {
                              followCursor: true,
                              placement: "bottom-end",
                              theme: _vm.isDarkMode ? "light-border" : "google",
                            },
                            expression:
                              "{\n                        followCursor: true,\n                        placement: 'bottom-end',\n                        theme: isDarkMode ? 'light-border' : 'google',\n                    }",
                          },
                        ],
                        attrs: {
                          id: "joinChat",
                          content: _vm.$t("wp.startChatWp"),
                          "data-v-step": "16",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.startChat(item.id)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.$t("wp.startChatWp")) +
                            "\n                    "
                        ),
                        _c(
                          "md-icon",
                          {
                            staticStyle: {
                              color: "#06e576",
                              "font-size": "12px",
                            },
                          },
                          [_vm._v(" whatsapp")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ])
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }